import { createContext } from 'react';

import { Customer, CustomerDetail } from '../../types';

type CustomerContextType = {
  selectedCustomer: Customer | null;
  setSelectedCustomer: (customer: Customer | null) => void;
  customerDetail: CustomerDetail | null;
  setCustomerDetail: (detail: CustomerDetail | null) => void;
};

const defaultValue: CustomerContextType = {
  selectedCustomer: null,
  setSelectedCustomer: () => {
    // Default empty function
  },
  customerDetail: null,
  setCustomerDetail: () => {
    // Default empty function
  },
};

export const CustomerContext = createContext<CustomerContextType>(defaultValue);

export type { Customer };
